// extracted by mini-css-extract-plugin
export default {"-large":"GDBYx0EtAMAw589uUZ9D","container":"TOHfEWRVaaYHByvYmdxb","tagContainer":"flxP5p_yvjwLVMe66dPX","iconBoxClass":"oc4U8MVCL80ZBlQieAmO"};